module.exports = __webpack_public_path__ + "img/gift2.a55f1713.png";